module.exports = __webpack_public_path__ + "static/media/01people_o.0ff47d72.png";